import SectionHeading from "@/components/base/SectionHeading";
import { timelineRows } from "@/pages/home/data";

export default function TimelineSection() {
  return (
    <section id="timeline" className="scroll-mt-20 w-full px-4 md:px-8 py-16 md:py-24 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <SectionHeading
          eyebrow="处理时长"
          title="每个阶段的处理时长，提前心里有数"
          description="下表为常规情况下的参考时效。若遇材料复杂、涉及多方核验，复核阶段可能延长，我们会通过查询编号同步最新进度。"
        />

        <div className="mt-10 md:mt-12 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          <table className="w-full text-left border-collapse">
            <caption className="sr-only">
              黑料投稿各处理阶段的参考时长与状态说明
            </caption>
            <thead>
              <tr className="bg-background-200/70">
                <th scope="col" className="px-4 md:px-6 py-3.5 text-xs md:text-sm font-semibold text-foreground-700">
                  处理阶段
                </th>
                <th scope="col" className="px-4 md:px-6 py-3.5 text-xs md:text-sm font-semibold text-foreground-700 whitespace-nowrap">
                  参考时长
                </th>
                <th scope="col" className="hidden md:table-cell px-6 py-3.5 text-xs md:text-sm font-semibold text-foreground-700">
                  说明
                </th>
                <th scope="col" className="px-4 md:px-6 py-3.5 text-xs md:text-sm font-semibold text-foreground-700 whitespace-nowrap">
                  进度
                </th>
              </tr>
            </thead>
            <tbody>
              {timelineRows.map((row, i) => (
                <tr
                  key={row.stage}
                  className={i % 2 === 1 ? "bg-background-100/60" : ""}
                >
                  <th
                    scope="row"
                    className="px-4 md:px-6 py-4 text-sm font-medium text-foreground-950 align-top"
                  >
                    <span className="inline-flex items-center gap-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
                      {row.stage}
                    </span>
                    <span className="block md:hidden mt-1 text-xs font-normal text-foreground-500">
                      {row.detail}
                    </span>
                  </th>
                  <td className="px-4 md:px-6 py-4 text-sm text-primary-700 font-medium align-top whitespace-nowrap">
                    {row.duration}
                  </td>
                  <td className="hidden md:table-cell px-6 py-4 text-sm text-foreground-600 align-top">
                    {row.detail}
                  </td>
                  <td className="px-4 md:px-6 py-4 align-top">
                    <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 whitespace-nowrap">
                      <i className="ri-checkbox-circle-line" aria-hidden="true"></i>
                      可查
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p className="mt-6 text-sm leading-relaxed text-foreground-500">
          提示：以上时长为工作日口径，节假日顺延。查询编号是跟进进度的唯一凭据，请妥善保存。
        </p>
      </div>
    </section>
  );
}